import type { ReactNode } from "react";

interface LayoutProps {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function Layout({ title, actions, children }: LayoutProps) {
  return (
    <div className="page">
      <header className="top-bar">
        <h1>{title}</h1>
        {actions}
      </header>
      <main className="container" style={{ flex: 1, width: "100%" }}>
        {children}
      </main>
    </div>
  );
}
